import { ReservationLinesStateInterface } from '.';

function state(): ReservationLinesStateInterface {
  return {
    reservationLines: [],
  };
}

export default state;
